import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Grid, Paper, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import TaskDeatilsTab from "../../../Constants/TaskManagement/TaskDetailsTab";
import strings from "../../../localization";
import DocumentList from "../../Document/Document/DocumentList";

const TaskDetails = () => {
    const [activeTab, setActiveTab] = useState(TaskDeatilsTab.FILES);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if(!location.state.task){
            navigate('/');
        }
    },[]);

    return <div id='task-details-page'>
        {
            <Paper className='paper'>
                <Grid container>
                    <Grid item xs={6}>
                        <div className='base-info'>
                            <h1>{location.state.task.name}</h1>
                            <h2>{location.state.task.pipeline?.name}</h2>
                            <p>{location.state.task.pipelineStage?.name}</p>
                        </div>
                    </Grid>
                </Grid>

                <CKEditor
                    disabled={true}
                    editor={ DecoupledEditor }
                    data={location.state.task.description}
                />
                </Paper>
        }
        <div className='tab-container'>
            <Paper className='paper'>
                <Tabs variant="scrollable" value={activeTab} onChange={(e, tab) => setActiveTab(tab)}>
                    <Tab label={strings.pages.taskManagement.tasks.taskDetails.files}/>
                </Tabs>
            </Paper>
        </div>
        {
            activeTab === TaskDeatilsTab.FILES &&
            <DocumentList referenceType={ReferenceType.TASK} id={location.state.task.id}/>
        }
        </div>
}

export default TaskDetails;